/**
 * AWS Amplify Configuration
 *
 * These values will be populated after deploying the backend.
 * Run `serverless deploy` in the backend directory and update these values
 * with the outputs from CloudFormation.
 *
 * You can find these values in:
 * - AWS Console > CloudFormation > top-dog-wholesale-dev > Outputs
 * - Or run: `serverless info --verbose` in the backend directory
 */

const awsConfig = {
  Auth: {
    Cognito: {
      // Replace with your User Pool ID from serverless deploy output
      // Format: us-east-1_xxxxxxxxx
      userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_PLACEHOLDER',

      // Replace with your User Pool Client ID from serverless deploy output
      // Format: xxxxxxxxxxxxxxxxxxxxxxxxxx
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || 'PLACEHOLDER_CLIENT_ID',

      // Login mechanisms
      loginWith: {
        email: true,
        username: false,
        phone: false,
      },

      // Sign up attributes
      signUpVerificationMethod: 'code' as const,

      // User attributes
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },

    },
  },
  API: {
    REST: {
      WholesaleAPI: {
        // Replace with your API Gateway endpoint from serverless deploy output
        // Format: https://xxxxxxxxxx.execute-api.us-east-1.amazonaws.com
        endpoint: import.meta.env.VITE_API_ENDPOINT || 'https://PLACEHOLDER.execute-api.us-east-1.amazonaws.com',
        region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
      },
    },
  },
};

export default awsConfig;

/**
 * Environment variable template for .env.local:
 *
 * VITE_USER_POOL_ID=us-east-1_xxxxxxxxx
 * VITE_USER_POOL_CLIENT_ID=xxxxxxxxxxxxxxxxxxxxxxxxxx
 * VITE_API_ENDPOINT=https://xxxxxxxxxx.execute-api.us-east-1.amazonaws.com
 * VITE_AWS_REGION=us-east-1
 */
